var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSearchBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6663 7.66634C12.6663 4.90492 10.4278 2.66634 7.66634 2.66634C4.90492 2.66634 2.66634 4.90492 2.66634 7.66634C2.66634 10.4278 4.90492 12.6663 7.66634 12.6663C9.04724 12.6663 10.2966 12.1077 11.2021 11.2021C12.1077 10.2966 12.6663 9.04724 12.6663 7.66634ZM13.9997 7.66634C13.9997 9.1748 13.4704 10.5599 12.5902 11.6475L14.471 13.5283L14.5166 13.5791C14.7302 13.841 14.7151 14.227 14.471 14.471C14.227 14.7151 13.841 14.7302 13.5791 14.5166L13.5283 14.471L11.6475 12.5902C10.5599 13.4704 9.1748 13.9997 7.66634 13.9997C4.16854 13.9997 1.33301 11.1641 1.33301 7.66634C1.33301 4.16854 4.16854 1.33301 7.66634 1.33301C11.1641 1.33301 13.9997 4.16854 13.9997 7.66634Z",
    fill: "#F3F2F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchBig);
export default __webpack_public_path__ + "static/media/icon-search-big.eb461fb855231a092f9d1bb160cae124.svg";
export { ForwardRef as ReactComponent };